import { defineMessages } from 'react-intl';

/** The copy of the Posts page (design assets-rethink c1, c2, c3, d2, d3). */
export const postsMessages = defineMessages({
  title: { id: 'app.sml.posts.title', defaultMessage: 'Posts' },
  subtitle: {
    id: 'app.sml.posts.subtitle',
    defaultMessage: 'Files to post one time. Archive a file when you are done with it.',
  },
  makeInStudio: { id: 'app.sml.posts.makeInStudio', defaultMessage: 'Make in Studio' },
  newPost: { id: 'app.sml.posts.newPost', defaultMessage: 'New post' },

  quotaUsed: { id: 'app.sml.posts.quota.used', defaultMessage: '{used} / {limit}' },
  quotaUsedNoLimit: { id: 'app.sml.posts.quota.usedNoLimit', defaultMessage: '{used}' },
  quotaCaption: {
    id: 'app.sml.posts.quota.caption',
    defaultMessage: 'Scheduled posts this month · {plan}',
  },

  allSongs: { id: 'app.sml.posts.filter.allSongs', defaultMessage: 'All songs' },
  songFilter: { id: 'app.sml.posts.filter.song', defaultMessage: 'Song' },
  allChannels: { id: 'app.sml.posts.filter.allChannels', defaultMessage: 'All channels' },
  channelFilter: { id: 'app.sml.posts.filter.channel', defaultMessage: 'Channel' },
  select: { id: 'app.sml.posts.select', defaultMessage: 'Select' },
  selectDone: { id: 'app.sml.posts.selectDone', defaultMessage: 'Done' },
  archiveLink: { id: 'app.sml.posts.archiveLink', defaultMessage: 'Archive · {count}' },

  making: { id: 'app.sml.posts.making', defaultMessage: 'Making · {count}' },
  makingPercent: { id: 'app.sml.posts.making.percent', defaultMessage: '{song} · {percent}%' },
  makingQueued: { id: 'app.sml.posts.making.queued', defaultMessage: '{song} · Queued' },
  makingWorking: { id: 'app.sml.posts.making.working', defaultMessage: '{song} · Making' },
  makingFailed: { id: 'app.sml.posts.making.failed', defaultMessage: '{song} · Failed, credits back' },
  makingPhone: {
    id: 'app.sml.posts.making.phone',
    defaultMessage: 'Making {count}{failed, plural, =0 {} one { · # failed} other { · # failed}}',
  },
  makingSee: { id: 'app.sml.posts.making.see', defaultMessage: 'See' },

  laneReady: { id: 'app.sml.posts.lane.ready', defaultMessage: 'Ready to post' },
  laneScheduled: { id: 'app.sml.posts.lane.scheduled', defaultMessage: 'Scheduled' },
  lanePosted: { id: 'app.sml.posts.lane.posted', defaultMessage: 'Posted' },
  laneReadyShort: { id: 'app.sml.posts.lane.readyShort', defaultMessage: 'Ready' },
  emptyReady: { id: 'app.sml.posts.lane.emptyReady', defaultMessage: 'Nothing waits to be posted.' },
  emptyScheduled: { id: 'app.sml.posts.lane.emptyScheduled', defaultMessage: 'Nothing on the calendar.' },
  emptyPosted: { id: 'app.sml.posts.lane.emptyPosted', defaultMessage: 'Nothing posted yet.' },
  showMore: { id: 'app.sml.posts.lane.showMore', defaultMessage: 'Show {count} more' },
  showLess: { id: 'app.sml.posts.lane.showLess', defaultMessage: 'Show less' },
  planThem: { id: 'app.sml.posts.lane.planThem', defaultMessage: 'Plan them' },
  openCalendar: { id: 'app.sml.posts.lane.openCalendar', defaultMessage: 'Open Calendar' },
  openSocial: { id: 'app.sml.posts.lane.openSocial', defaultMessage: 'Open in Social' },

  songOutIn: {
    id: 'app.sml.posts.song.outIn',
    defaultMessage: '{song} · out in {days, plural, one {# day} other {# days}}',
  },
  songOutToday: { id: 'app.sml.posts.song.outToday', defaultMessage: '{song} · out today' },
  songOut: { id: 'app.sml.posts.song.out', defaultMessage: '{song} · out {date}' },
  noSong: { id: 'app.sml.posts.song.none', defaultMessage: 'No song' },

  madeToday: { id: 'app.sml.posts.made.today', defaultMessage: 'Made today, {time}' },
  madeOn: { id: 'app.sml.posts.made.on', defaultMessage: 'Made {date}' },
  review: { id: 'app.sml.posts.review', defaultMessage: 'Review' },
  postIt: { id: 'app.sml.posts.postIt', defaultMessage: 'Post it' },

  dayToday: { id: 'app.sml.posts.day.today', defaultMessage: 'Today · {date}' },
  dayTomorrow: { id: 'app.sml.posts.day.tomorrow', defaultMessage: 'Tomorrow · {date}' },
  draft: { id: 'app.sml.posts.post.draft', defaultMessage: 'Draft' },
  needsYou: { id: 'app.sml.posts.post.needsYou', defaultMessage: 'Needs you' },
  publishing: { id: 'app.sml.posts.post.publishing', defaultMessage: 'Posting' },
  captionNotSet: { id: 'app.sml.posts.post.captionNotSet', defaultMessage: '{song} · caption not set' },

  periodThisWeek: { id: 'app.sml.posts.period.thisWeek', defaultMessage: 'This week' },
  postedOn: { id: 'app.sml.posts.posted.on', defaultMessage: '{song} · {date}' },
  failedOn: { id: 'app.sml.posts.posted.failedOn', defaultMessage: 'Failed on {channel} · {date}' },
  failed: { id: 'app.sml.posts.posted.failed', defaultMessage: 'Failed' },
  retry: { id: 'app.sml.posts.posted.retry', defaultMessage: 'Retry' },
  views: { id: 'app.sml.posts.numbers.views', defaultMessage: '{count} views' },
  likes: { id: 'app.sml.posts.numbers.likes', defaultMessage: '{count} likes' },

  archive: { id: 'app.sml.posts.archive', defaultMessage: 'Archive' },
  moreActions: { id: 'app.sml.posts.moreActions', defaultMessage: 'More actions' },
  pickFile: { id: 'app.sml.posts.pickFile', defaultMessage: 'Pick {name}' },
  picked: { id: 'app.sml.posts.select.picked', defaultMessage: '{count} picked' },
  pickAll: { id: 'app.sml.posts.select.pickAll', defaultMessage: 'Pick all {count}' },
  archiveCount: { id: 'app.sml.posts.select.archiveCount', defaultMessage: 'Archive {count}' },
  archived: {
    id: 'app.sml.posts.archived.toast',
    defaultMessage: '{count, plural, one {# file archived} other {# files archived}}',
  },
  blocked: {
    id: 'app.sml.posts.blocked',
    defaultMessage:
      '{count, plural, one {# file has} other {# files have}} a draft or a scheduled post. Cancel the post first.',
  },
  blockedOpen: { id: 'app.sml.posts.blocked.open', defaultMessage: 'Open the post' },
  actionFailed: { id: 'app.sml.posts.actionFailed', defaultMessage: 'That did not work. Try again.' },

  archiveTitle: { id: 'app.sml.posts.archive.title', defaultMessage: 'Archive' },
  archiveSubtitle: {
    id: 'app.sml.posts.archive.subtitle',
    defaultMessage: 'Files you archived. They stay here forever. Restore puts a file back on the board.',
  },
  backToPosts: { id: 'app.sml.posts.archive.back', defaultMessage: 'Back to Posts' },
  archiveAll: { id: 'app.sml.posts.archive.all', defaultMessage: 'All · {count}' },
  archivePosted: { id: 'app.sml.posts.archive.posted', defaultMessage: 'Posted · {count}' },
  archiveNever: { id: 'app.sml.posts.archive.never', defaultMessage: 'Never posted · {count}' },
  columnFile: { id: 'app.sml.posts.archive.column.file', defaultMessage: 'File' },
  columnOutcome: { id: 'app.sml.posts.archive.column.outcome', defaultMessage: 'Outcome' },
  columnArchived: { id: 'app.sml.posts.archive.column.archived', defaultMessage: 'Archived' },
  columnNumbers: { id: 'app.sml.posts.archive.column.numbers', defaultMessage: 'Numbers' },
  outcomePosted: { id: 'app.sml.posts.archive.outcome.posted', defaultMessage: 'Posted {date}' },
  outcomeNever: { id: 'app.sml.posts.archive.outcome.never', defaultMessage: 'Never posted' },
  restore: { id: 'app.sml.posts.archive.restore', defaultMessage: 'Restore' },
  archiveEmpty: { id: 'app.sml.posts.archive.empty', defaultMessage: 'Nothing is in the archive.' },

  emptyTitle: { id: 'app.sml.posts.empty.title', defaultMessage: 'No posts to make yet' },
  emptyBody: {
    id: 'app.sml.posts.empty.body',
    defaultMessage:
      'Plan the rollout of a song and we make the stories, feed posts and countdowns for each day. Or post your own photo or video.',
  },
  planRollout: { id: 'app.sml.posts.empty.planRollout', defaultMessage: 'Plan a rollout' },

  demoNote: {
    id: 'app.sml.posts.note.demo',
    defaultMessage: 'This is the example artist LaziiBee. You can look, but not archive.',
  },
  reelLabel: { id: 'app.sml.posts.reelLabel', defaultMessage: 'AI reel {length}' },
  // The rollout day of a file or a post (owner request 2026-10-09; design assets-rethink c1).
  rolloutDay: { id: 'app.sml.posts.rolloutDay', defaultMessage: 'Rollout day {offset}' },
});
